import * as React from "react";
import { AppShape } from "@eave/shared/types/api";
import { formatCurrency } from "@eave/shared/utils/currency";
import { verticalHeaderTRUSTable } from "./shared";

const styles = require("./styles.module.scss");

interface Props {
  app: AppShape;
}

const LiabilitiesInfo: React.FC<Props> = ({ app }: Props) => {
  const table1 = [
    {
      label: "All Other Monthly Payments",
      value: formatCurrency(app.decision.existing_monthly_debt, 2, 2),
    },
  ];
  return (
    <>
      <h2>Liabilities</h2>
      <div className={styles.table}>{verticalHeaderTRUSTable(table1)}</div>
    </>
  );
};

export default LiabilitiesInfo;
